import { IOrderLocation, IOrderLocationsGroup } from "../state/venueAreas.reducer";

export function createOrderLocationGroupsObject(locationGroups: Partial<IOrderLocationsGroup>[], venue_group_id?:string) {
  const groups:any = [];
  let error:Record<string,string[]> = {};
  let enabledCount = 0;

  locationGroups.forEach((group) => {
    if(group.enabled){
      enabledCount += 1;
    }
    if(group.order_locations?.length===0 || !group.order_locations){
      error[group.id!] = []
    }else{
      if (group.isNewField) {
        groups.push({
         ...( venue_group_id ? {venue_group_id:venue_group_id} : {venue_id: group.venue_id}),
          name_public: group.name_public,
          name_private: group.name_private,
          enabled:group.enabled,
          order_locations: group.order_locations?.map((location: Partial<IOrderLocation>) => {
            if(location.name_public?.length === 0 || !location.name_public){
              if(!error[group.id!]){
                error[group.id!] = [];
              }
              error[group.id!].push(location.id!)
              return null;
            }
            if (location.isNewField) {
              delete location.id;
              if (group.isNewField) {
                delete location.group_id;
              }
              delete location.isNewField;
            }
            return location;
          })
        })
      } else {
        groups.push({
          id: group.id,
          ...( venue_group_id ? {venue_group_id:venue_group_id} : {venue_id: group.venue_id}),
          name_public: group.name_public,
          name_private: group.name_private,
          enabled:group.enabled,
          order_locations: group.order_locations?.map((location: Partial<IOrderLocation>) => {
            if(location.name_public?.length === 0 || !location.name_public){
              if(!error[group.id!]){
                error[group.id!] = [];
              }
              error[group.id!].push(location.id!)
              return null;
            }
            if (location.isNewField) {
              delete location.id;
              if (group.isNewField) {
                delete location.group_id;
              }
              delete location.isNewField;
            }
            return location;
          })
        })
      }
    }
    
  })
  
  return {
    groups,
    error,
    enabledCount
  };
}